export default "__VITE_ASSET__C6oFLB5Y__"